// Lightweight Google Analytics 4 event helper.
// Safely no-ops if gtag isn't available (e.g. during SSR or if blocked).
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) {
    // never let analytics break the UI
  }
}
